import { instance as axios } from "@/services/axios";
export const state = () => ({
  state: {
    stateGetDisplayCondition: null,
    stateGetWebCondition: null,
    stateGetWebConditionOperation: null,
    stateGetWebAutomationSettingDetail: null,
    stateUpdateWebAutomationSettingDetail: null,
    stateGetWebAutomationComponenList: null,
    stateGetWebAutomationComponentDetail: null,
    stateCreateWebAutomationComponent: null,
    stateUpdateWebAutomationComponent: null,
    stateDeleteWebAutomationComponent: null,
    stateGetDashboardPerformance: null,
    stateGetDashboardCustomerList: null,
    stateExportCustomerList: null,
  },
});

export const mutations = {
  setGetDisplayCondition: async function (state, val) {
    state.stateGetDisplayCondition = val;
  },
  setGetWebCondition: async function (state, val) {
    state.stateGetWebCondition = val;
  },
  setGetWebConditionOperation: async function (state, val) {
    state.stateGetWebConditionOperation = val;
  },
  setGetWebAutomationSettingDetail: async function (state, val) {
    state.stateGetWebAutomationSettingDetail = val;
  },
  setUpdateWebAutomationSettingDetail: async function (state, val) {
    state.stateUpdateWebAutomationSettingDetail = val;
  },
  setGetWebAutomationComponentList: async function (state, val) {
    state.stateGetWebAutomationComponentList = val;
  },
  setGetWebAutomationComponentDetail: async function (state, val) {
    state.stateGetWebAutomationComponentDetail = val;
  },
  setCreateWebAutomationComponent: async function (state, val) {
    state.stateCreateWebAutomationComponent = val;
  },
  setUpdateWebAutomationComponent: async function (state, val) {
    state.stateUpdateWebAutomationComponent = val;
  },
  setDeleteWebAutomationComponent: async function (state, val) {
    state.stateDeleteWebAutomationComponent = val;
  },
  setGetDashboardCustomerList: async function (state, val) {
    state.stateGetDashboardCustomerList = val;
  },
  setGetDashboardPerformance: async function (state, val) {
    state.stateGetDashboardPerformance = val;
  },
  setGetExportCustomerList: async function (state, val) {
    state.stateExportCustomerList = val;
  },
};

export const actions = {
  getDisplayCondition: async ({ commit }) => {
    await axios.get(`/WebAutomation/displayCondition`).then(
      async (data) => {
        commit("setGetDisplayCondition", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getWebCondition: async ({ commit }) => {
    await axios.get(`/WebAutomation/WebCondition`).then(
      async (data) => {
        commit("setGetWebCondition", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getWebConditionOperation: async ({ commit }) => {
    await axios.get(`/WebAutomation/WebConditionOperation`).then(
      async (data) => {
        commit("setGetWebConditionOperation", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getWebAutomationSettingDetail: async ({ commit }) => {
    await axios.get(`/WebAutomation/settingDetail`).then(
      async (data) => {
        commit("setGetWebAutomationSettingDetail", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  updateWebAutomationSettingDetail: async ({ commit }, payload) => {
    await axios.put(`/WebAutomation/SettingDetail`, payload).then(
      async (data) => {
        commit("setUpdateWebAutomationSettingDetail", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getWebAutomationComponentList: async ({ commit }, payload) => {
    await axios.post(`/WebAutomation/search`, payload).then(
      async (data) => {
        commit("setGetWebAutomationComponentList", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getWebAutomationComponentDetail: async ({ commit }, payload) => {
    await axios.get(`/WebAutomation/${payload}`).then(
      async (data) => {
        commit("setGetWebAutomationComponentDetail", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  createWebAutomationComponent: async ({ commit }, payload) => {
    await axios.post(`/WebAutomation`, payload).then(
      async (data) => {
        commit("setCreateWebAutomationComponent", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  updateWebAutomationComponent: async ({ commit }, payload) => {
    await axios.put(`/WebAutomation`, payload).then(
      async (data) => {
        commit("setUpdateWebAutomationComponent", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  deleteWebAutomationComponent: async ({ commit }, payload) => {
    await axios.delete(`/WebAutomation/${payload}`).then(
      async (data) => {
        commit("setDeleteWebAutomationComponent", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getDashboardCustomerList: async ({ commit }, payload) => {
    await axios.post(`/WebAutomation/Dashboard/CustomerList`, payload).then(
      async (data) => {
        commit("setGetDashboardCustomerList", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getDashboardPerformance: async ({ commit }, payload) => {
    await axios.post(`/WebAutomation/Dashboard/Performance`, payload).then(
      async (data) => {
        commit("setGetDashboardPerformance", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  exportWebautomationUser: async ({ commit }, payload) => {
    await axios
      .post(`/WebAutomation/Dashboard/ExportCustomerList`, payload, {
        responseType: "blob",
      })
      .then(
        (data) => {
          commit("setGetExportCustomerList", data);
        },
        (error) => {
          const code = parseInt(error.response && error.response.status);
          if (code === 401) {
            commit("setModalAlertLogin", true);
          }
        }
      );
  },
};
export const getters = {};

export default {
  state,
  actions,
  mutations,
  getters,
};
